import { render, staticRenderFns } from "./wbdp-group-config.vue?vue&type=template&id=810cb9ba"
import script from "./wbdp-group-config.vue?vue&type=script&lang=js"
export * from "./wbdp-group-config.vue?vue&type=script&lang=js"
import style0 from "./wbdp-group-config.vue?vue&type=style&index=0&id=810cb9ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports